import { EImportSectionsTarget } from '@constants';
import { ISection } from '@sdk/contracts';
import { Button, Divider, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './IntroductionActivities.styles';
import { IntroductionActivityItem } from './IntroductionActivityItem';

import { Icon } from '@/components/Icon';
import { ImportActivity } from '@/components/SectionManagement';
import { useCurrentSection, useIntroductionForm, useLocalCourse } from '@/store';

type Props = {
  section: ISection;
  fetchOnlyParentsCourses?: boolean;
};

export const IntroductionActivities: React.FC<Props> = ({ section, fetchOnlyParentsCourses }) => {
  const { t } = useTranslation('CourseTranslations');
  const { setIsOpen } = useIntroductionForm();
  const { setCurrentSectionId } = useCurrentSection();
  const { course } = useLocalCourse();
  const { parentSection } = section;

  if (!course) return null;

  return (
    <Wrapper>
      {section.activities.map(activity => (
        <IntroductionActivityItem key={activity._id} section={section} activity={activity} />
      ))}
      {!parentSection && (
        <>
          <Divider dashed />
          <Flex gap={8}>
            <Button
              type="default"
              onClick={() => {
                setCurrentSectionId(section._id);
                setIsOpen(true);
              }}
              icon={<Icon i="Add" />}>
              {t('ADD_ACTIVITY')}
            </Button>
            <ImportActivity
              courseId={course._id}
              sectionId={section._id}
              target={EImportSectionsTarget.INTRODUCTION}
              fetchOnlyParentsCourses={fetchOnlyParentsCourses}
            />
          </Flex>
        </>
      )}
    </Wrapper>
  );
};
